// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/cross.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chip-container {
  padding: 5.56px 11.13px 5.56px 11.13px;
  gap: 9.74px;
  border-radius: 75.11px;
  display: flex;
  align-items: center;
  opacity: 1;
  width: max-content;
}

.required-staric-color {
  color: red !important;
}

.no-border {
  border: none !important;
}

.view-progess-label {
  border-bottom: 3px dotted #5a6a85;
  color: #5a6a85;
  cursor: pointer;
}

.defaultBorderRadius {
  border-radius: 10px !important;
}

.view-progess-label:hover {
  border-bottom: 3px dotted rgb(156, 161, 169);
  color: rgb(156, 161, 169);
}

.chip-text {
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 17.64px;
  text-align: left;
}

.searchbar-styles span {
  color: #1d2026 !important;
  background-color: white;
  border-color: white;
  height: 48px;
  border-radius: 0px !important;
}
.searchbar-styles input {
  color: #8c94a3 !important;
  background-color: white;
  border-color: white;
  border-radius: 0px !important;
}
.searchbar-styles input:focus {
  outline: none;
  box-shadow: none;
  color: #8c94a3 !important;
  background-color: white;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-color: white !important;
}
.searchbar-styles input::placeholder {
  color: #8c94a3 !important;
}

.label-styles {
  font-family: Plus Jakarta Sans !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 22px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #1d2026;
  margin-bottom: 6px;
}

.styled-text-field span {
  font-family: Plus Jakarta Sans;
  color: #4e5566;
  border: 1px solid #e9eaf0;
  background-color: white;
  border-left-color: white;
  height: 48px;
  border-radius: 0px !important;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.01em;
  text-align: right;
}
.styled-text-field input {
  font-family: Plus Jakarta Sans;
  color: #8c94a3 !important;
  border-top: 1px solid #e9eaf0 !important;
  border-bottom: 1px solid #e9eaf0 !important;
  border-left: 1px solid #e9eaf0 !important;
  height: 48px;
  border-radius: 0px !important;
}
.styled-text-field input:focus {
  color: #8c94a3 !important;
  border-top: 1px solid #8b8b8e !important;
  border-bottom: 1px solid #e9eaf0 !important;
  border-left: 1px solid #e9eaf0 !important;
}
.styled-text-field input::placeholder {
  color: #8c94a3 !important;
}

.team-and-access .label-styles {
  font-family: Plus Jakarta Sans !important;
  font-size: 18px !important;
  font-weight: 500 !important;
  line-height: 24px !important;
  text-align: left !important;
  color: #1d2026;
  margin-bottom: 24px !important;
}
.team-and-access .add-new {
  font-family: Plus Jakarta Sans !important;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #564ffd;
  display: flex;
  align-items: center;
}
.team-and-access .add-new img {
  color: #564ffd !important;
  margin-right: 8px;
  height: 16px;
  width: 16px;
}

.styled-select-field .css-13cymwt-control {
  min-height: 48px !important;
  background-color: white;
  border: 1px solid #e9eaf0 !important;
  border-radius: 0 !important;
}
.styled-select-field .css-13cymwt-control:focus {
  min-height: 48px !important;
  background-color: white;
  border: 1px solid #e9eaf0 !important;
  border-radius: 0 !important;
}
.styled-select-field .css-1dimb5e-singleValue {
  color: #8c94a3 !important;
}
.styled-select-field .react-select__option {
  color: #8c94a3 !important;
}
.styled-select-field .singal-select__indicators {
  min-height: 48px !important;
}
.styled-select-field .singal-select__menu {
  z-index: 2 !important;
}
.styled-select-field .css-1u9des2-indicatorSeparator {
  display: none;
}
.styled-select-field .css-1xc3v61-indicatorContainer {
  color: #1d2026;
}
.styled-select-field .css-1xc3v61-indicatorContainer svg {
  height: 18px;
  width: 18px;
}

.calender-select-field span {
  font-family: Plus Jakarta Sans;
  color: #4e5566 !important;
  border: 1px solid #e9eaf0;
  background-color: white;
  border-left-color: white;
  height: 48px;
  border-radius: 0px !important;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.01em;
  text-align: right;
}
.calender-select-field input {
  font-family: Plus Jakarta Sans;
  color: #8c94a3 !important;
  border: 1px solid #e9eaf0 !important;
  height: 49.6px !important;
  width: 100%;
  border-radius: 0px !important;
  padding-left: 12px;
  padding-right: 12px;
}
.calender-select-field input:focus {
  color: #8c94a3 !important;
}
.calender-select-field input::placeholder {
  color: #8c94a3 !important;
}

.styled-multi-select-field .multi-select-dropdown__multi-value {
  display: flex;
  min-width: 0;
  background-color: hsl(0, 0%, 90%);
  border-radius: 50px !important;
  margin: 2px;
  box-sizing: border-box;
  padding: 1px 5px;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  gap: 5px;
}
.styled-multi-select-field .multi-select-dropdown__control {
  min-height: 48px !important;
  background-color: white;
  border: 1px solid #e9eaf0 !important;
  border-radius: 0 !important;
}
.styled-multi-select-field .multi-select-dropdown__control:focus {
  min-height: 48px !important;
  background-color: white;
  border: 1px solid #e9eaf0 !important;
  border-radius: 0 !important;
}
.styled-multi-select-field .css-1dimb5e-singleValue {
  color: #8c94a3 !important;
}
.styled-multi-select-field .react-select__option {
  color: #8c94a3 !important;
}
.styled-multi-select-field .css-1hb7zxy-IndicatorsContainer {
  height: 48px !important;
}
.styled-multi-select-field .css-1u9des2-indicatorSeparator {
  display: none;
}
.styled-multi-select-field .css-1xc3v61-indicatorContainer {
  color: #1d2026;
}
.styled-multi-select-field .css-1xc3v61-indicatorContainer svg {
  height: 18px;
  width: 18px;
}

.styled-multi-select-field .multi-select-dropdown__multi-value {
  display: flex;
  min-width: 0;
  background-color: hsl(0, 0%, 90%);
  border-radius: 50px !important;
  margin: 2px;
  box-sizing: border-box;
  padding: 1px 5px;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  gap: 5px;
}
.styled-multi-select-field .multi-select-dropdown__control {
  min-height: 48px !important;
  background-color: white;
}
.styled-multi-select-field .multi-select-dropdown__control:focus {
  min-height: 48px !important;
  background-color: white;
}
.styled-multi-select-field .css-1dimb5e-singleValue {
  color: #8c94a3 !important;
}
.styled-multi-select-field .react-select__option {
  color: #8c94a3 !important;
}
.styled-multi-select-field .multi-select-dropdown__indicators {
  min-height: 48px !important;
}
.styled-multi-select-field .css-1u9des2-indicatorSeparator {
  display: none;
}
.styled-multi-select-field .css-1xc3v61-indicatorContainer {
  color: #1d2026 !important;
}
.styled-multi-select-field .css-1xc3v61-indicatorContainer svg {
  height: 18px;
  width: 18px;
}
.styled-multi-select-field .css-1xc3v61-indicatorContainer svg:focus {
  height: 18px;
  width: 18px;
}
.styled-multi-select-field .css-1xc3v61-indicatorContainer:focus:hover {
  color: #1d2026 !important;
  svg-height: 18px;
  svg-width: 18px;
}
.styled-multi-select-field .css-1xc3v61-indicatorContainer:focus:hover svg:focus {
  height: 18px;
  width: 18px;
}
.styled-multi-select-field .multi-select-dropdown__multi-value__remove {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  /* Set appropriate width and height for your custom image */
  width: 20px;
  height: 20px;
  border-radius: 50px !important;
  /* Ensure the image is displayed properly */
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
  border: none !important;
  /* Ensure cursor changes on hover */
}

.module-trash-icon {
  cursor: pointer;
}
.module-trash-icon :hover {
  color: #e34444 !important;
}

.styled-textarea-field textarea {
  font-family: Plus Jakarta Sans;
  color: #8c94a3 !important;
  border: 1px solid #e9eaf0;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  height: 200px;
  resize: none;
  border-radius: 0px !important;
}
.styled-textarea-field textarea::placeholder {
  color: #8c94a3 !important;
}

.styled-file-input-field .button-styles {
  color: #4e5566 !important;
  border: 1px solid #e9eaf0;
  background: #e9eaf0 !important;
  background-color: white;
  border-left-color: white;
  height: 48px !important;
  color: #1d2026;
  font-family: Plus Jakarta Sans;
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px !important;
  margin-left: -8px !important;
  z-index: 1;
  cursor: pointer;
}
.styled-file-input-field .input-file {
  font-family: Plus Jakarta Sans;
  color: #8c94a3 !important;
  background-color: white !important;
  border: 1px solid #e9eaf0 !important;
  height: 48px;
  align-items: center;
  display: flex;
  padding-left: 18px;
  border-radius: 0px !important;
  cursor: pointer;
}
.styled-file-input-field .info-message {
  margin: 0px !important;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.01em;
  text-align: left;
}
.styled-file-input-field .info-message .note {
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.01em;
  text-align: left;
  background-color: white !important;
}

.styled-checkboxes-field .label-styles {
  font-family: Plus Jakarta Sans !important;
  font-size: 18px !important;
  font-weight: 500 !important;
  line-height: 24px !important;
  text-align: left !important;
  color: #1d2026;
  margin-bottom: 24px !important;
}
.styled-checkboxes-field .form-check-input {
  height: 18px;
  width: 18px;
}
.styled-checkboxes-field .form-check-input:checked {
  background-color: #564ffd !important;
  color: #ffffff !important;
}
.styled-checkboxes-field .form-check label {
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #1d2026;
}

.input-group span {
  color: #1d2026 !important;
  background-color: white;
  border-color: white;
  height: 48px;
  border-radius: 0px !important;
}

.input-group input {
  color: #8c94a3 !important;
  background-color: white;
  border-color: white;
  border-radius: 0px !important;
}

.input-group input::placeholder {
  color: #8c94a3 !important;
}

.classroom-table tr {
  height: 36px !important;
  text-align: start !important;
}
.classroom-table td {
  height: 36px !important;
  padding: 0px 8px !important;
  text-align: start !important;
  width: inherit !important;
  overflow: visible !important;
}
.classroom-table td > div:first-child {
  height: 100% !important;
  display: flex;
  align-items: center;
  width: 100% !important;
}
.classroom-table td:last-child {
  overflow: visible !important;
}
.classroom-table th {
  height: 50px !important;
  position: relative;
  padding: 0px 8px !important;
}
.classroom-table .table-checkbox {
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 20px;
  height: 20px;
}
.classroom-table table input:checked {
  background-color: #4403bf;
}

@media (max-width: 1024px) {
  .classroom-table th {
    font-size: 14px !important;
    line-height: 18px !important;
  }
  .classroom-table td {
    font-size: 12px !important;
    line-height: 16px !important;
  }
  .classroom-table td > div,
  .classroom-table th > div {
    font-size: 12px !important;
    line-height: 16px !important;
  }
}
.styled-button-styles {
  font-family: Plus Jakarta Sans;
  font-size: 16px;
  font-weight: 600 !important;
  line-height: 17.34px;
  text-align: left !important;
  padding: 11.14px 25.46px 11.14px 25.46px !important;
  color: #564ffd !important;
  background-color: #ebebff !important;
  border-color: #ebebff !important;
}
@media (max-width: 768px) {
  .styled-button-styles {
    font-size: 10px !important;
    padding: 10px 20px !important;
  }
}
@media (max-width: 480px) {
  .styled-button-styles {
    font-size: 10px !important;
    padding: 7px 10px !important;
  }
}
@media (max-width: 360px) {
  .styled-button-styles {
    font-size: 10px !important;
    padding: 5px 7px !important;
  }
}

.styled-button-styles:hover {
  color: white !important;
  background-color: #564ffd !important;
}

.styled-link-button {
  font-family: Plus Jakarta Sans;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 17.34px;
  text-align: left !important;
  color: #564ffd !important;
}
@media (max-width: 768px) {
  .styled-link-button {
    font-size: 14px !important;
  }
}
@media (max-width: 480px) {
  .styled-link-button {
    font-size: 12px !important;
  }
}

table input:checked {
  background-color: #4403bf;
}

.line {
  height: 1px;
  background-color: #5a6a85;
  width: 100%;
  margin: auto;
  margin-left: 10px;
}

.table-responsive {
  width: 100% !important;
  overflow: visible !important;
}

.options-toggle {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.dropdown-toggle {
  display: inline-flex !important;
  align-items: center !important;
}

.dropdown-menu {
  z-index: 9999 !important;
  min-width: 120px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
}
.dropdown-menu.show {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

.dropdown-item {
  cursor: pointer;
}
.dropdown-item:hover {
  background-color: #f8f8f8;
}
.dropdown-item:active {
  background-color: #f0f0f0;
}`, "",{"version":3,"sources":["webpack://./src/components/Classroom/styles.scss"],"names":[],"mappings":"AAEA;EACE,sCAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;AADF;;AAIA;EACE,qBAAA;AADF;;AAIA;EACE,uBAAA;AADF;;AAIA;EACE,iCAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;EACE,8BAAA;AADF;;AAIA;EACE,4CAAA;EACA,yBAAA;AADF;;AAIA;EACE,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;AADF;;AAKE;EACE,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,6BAAA;AAFJ;AAKE;EACE,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,6BAAA;AAHJ;AAME;EACE,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,uBAAA;EACA,2DAAA;EACA,8BAAA;AAJJ;AAOE;EACE,yBAAA;AALJ;;AASA;EACE,yCAAA;EACA,0BAAA;EACA,2BAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AANF;;AAUE;EACE,8BAAA;EACA,cAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,iBAAA;AAPJ;AAUE;EACE,8BAAA;EACA,yBAAA;EACA,wCAAA;EACA,2CAAA;EACA,yCAAA;EACA,YAAA;EACA,6BAAA;AARJ;AAWE;EACE,yBAAA;EACA,wCAAA;EACA,2CAAA;EACA,yCAAA;AATJ;AAqBE;EACE,yBAAA;AAnBJ;;AAwBE;EACE,yCAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,8BAAA;AArBJ;AAwBE;EACE,yCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAtBJ;AAwBI;EACE,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;AAtBN;;AA4BE;EACE,2BAAA;EACA,uBAAA;EACA,oCAAA;EACA,2BAAA;AAzBJ;AA4BE;EACE,2BAAA;EACA,uBAAA;EACA,oCAAA;EACA,2BAAA;AA1BJ;AA6BE;EACE,yBAAA;AA3BJ;AA8BE;EACE,yBAAA;AA5BJ;AA+BE;EACE,2BAAA;AA7BJ;AAgCE;EACE,qBAAA;AA9BJ;AAiCE;EACE,aAAA;AA/BJ;AAkCE;EACE,cAAA;AAhCJ;AAiCI;EACE,YAAA;EACA,WAAA;AA/BN;;AAqCE;EACE,8BAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,iBAAA;AAlCJ;AAqCE;EACE,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,yBAAA;EACA,WAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;AAnCJ;AAsCE;EACE,yBAAA;AApCJ;AAuCE;EACE,yBAAA;AArCJ;;AA0CE;EACE,aAAA;EACA,YAAA;EACA,iCAAA;EACA,8BAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EAIA,uBAAA;EAIA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,QAAA;AAvCJ;AA0CE;EACE,2BAAA;EACA,uBAAA;EACA,oCAAA;EACA,2BAAA;AAxCJ;AA2CE;EACE,2BAAA;EACA,uBAAA;EACA,oCAAA;EACA,2BAAA;AAzCJ;AA4CE;EACE,yBAAA;AA1CJ;AA6CE;EACE,yBAAA;AA3CJ;AA8CE;EACE,uBAAA;AA5CJ;AA+CE;EACE,aAAA;AA7CJ;AAgDE;EACE,cAAA;AA9CJ;AA+CI;EACE,YAAA;EACA,WAAA;AA7CN;;AAmDE;EACE,aAAA;EACA,YAAA;EACA,iCAAA;EACA,8BAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EAIA,uBAAA;EAIA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,QAAA;AAhDJ;AAmDE;EACE,2BAAA;EACA,uBAAA;AAjDJ;AAoDE;EACE,2BAAA;EACA,uBAAA;AAlDJ;AAqDE;EACE,yBAAA;AAnDJ;AAsDE;EACE,yBAAA;AApDJ;AAuDE;EACE,2BAAA;AArDJ;AAwDE;EACE,aAAA;AAtDJ;AAyDE;EACE,yBAAA;AAvDJ;AAyDI;EACE,YAAA;EACA,WAAA;AAvDN;AA0DI;EACE,YAAA;EACA,WAAA;AAxDN;AA4DE;EACE,yBAAA;EAGE,gBAAA;EACA,eAAA;AA5DN;AA+DI;EACE,YAAA;EACA,WAAA;AA7DN;AAiEE;EACE,oEAAA;EACA,2DAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,2CAAA;EACA,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,uBAAA;EACA,mCAAA;AA/DJ;;AAmEA;EACE,eAAA;AAhEF;AAiEE;EACE,yBAAA;AA/DJ;;AAoEE;EACE,8BAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,6BAAA;AAjEJ;AAoEE;EACE,yBAAA;AAlEJ;;AAuEE;EACE,yBAAA;EACA,yBAAA;EACA,8BAAA;EACA,uBAAA;EACA,wBAAA;EACA,uBAAA;EACA,cAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,4BAAA;EACA,UAAA;EACA,eAAA;AApEJ;AAuEE;EACE,8BAAA;EACA,yBAAA;EACA,kCAAA;EACA,oCAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;AArEJ;AAwEE;EAWE,sBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AAhFJ;AAgEI;EACE,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kCAAA;AA9DN;;AA4EE;EACE,yCAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,8BAAA;AAzEJ;AA4EE;EACE,YAAA;EACA,WAAA;AA1EJ;AA6EE;EACE,oCAAA;EACA,yBAAA;AA3EJ;AA8EE;EACE,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AA5EJ;;AAgFA;EACE,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,6BAAA;AA7EF;;AAgFA;EACE,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,6BAAA;AA7EF;;AAyFA;EACE,yBAAA;AAtFF;;AA0FE;EACE,uBAAA;EACA,4BAAA;AAvFJ;AA0FE;EACE,uBAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,4BAAA;AAxFJ;AA2FE;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AAzFJ;AA4FE;EACE,4BAAA;AA1FJ;AA6FE;EACE,uBAAA;EACA,kBAAA;EACA,2BAAA;AA3FJ;AA8FE;EACE,kBAAA;EACA,YAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;AA5FJ;AA+FE;EACE,yBAjkBY;AAoehB;;AAiGA;EAEI;IACE,0BAAA;IACA,4BAAA;EA/FJ;EAiGE;IACE,0BAAA;IACA,4BAAA;EA/FJ;EAiGE;;IAEE,0BAAA;IACA,4BAAA;EA/FJ;AACF;AAmGA;EACE,8BAAA;EACA,eAAA;EACA,2BAAA;EACA,oBAAA;EACA,2BAAA;EACA,mDAAA;EACA,yBAAA;EACA,oCAAA;EACA,gCAAA;AAjGF;AAmGE;EAXF;IAYI,0BAAA;IACA,6BAAA;EAhGF;AACF;AAkGE;EAhBF;IAiBI,0BAAA;IACA,4BAAA;EA/FF;AACF;AAiGE;EArBF;IAsBI,0BAAA;IACA,2BAAA;EA9FF;AACF;;AAiGA;EACE,uBAAA;EACA,oCAAA;AA9FF;;AAiGA;EACE,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,oBAAA;EACA,2BAAA;EACA,yBAAA;AA9FF;AAgGE;EARF;IASI,0BAAA;EA7FF;AACF;AA+FE;EAZF;IAaI,0BAAA;EA5FF;AACF;;AA+FA;EACE,yBAzoBc;AA6iBhB;;AA+FA;EACE,WAAA;EAEA,yBAAA;EACA,WAAA;EAEA,YAAA;EACA,iBAAA;AA9FF;;AAiGA;EACE,sBAAA;EACA,4BAAA;AA9FF;;AAkGA;EACE,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AA/FF;;AAkGA;EACE,+BAAA;EACA,8BAAA;AA/FF;;AAkGA;EACE,wBAAA;EACA,gBAAA;EACA,oDAAA;AA/FF;AAiGE;EACE,yBAAA;EACA,8BAAA;EACA,qBAAA;AA/FJ;;AAmGA;EACE,eAAA;AAhGF;AAkGE;EACE,yBAAA;AAhGJ;AAmGE;EACE,yBAAA;AAjGJ","sourcesContent":["$primary-color: #4403bf;\n\n.chip-container {\n  padding: 5.56px 11.13px 5.56px 11.13px;\n  gap: 9.74px;\n  border-radius: 75.11px;\n  display: flex;\n  align-items: center;\n  opacity: 1;\n  width: max-content;\n}\n\n.required-staric-color {\n  color: red !important;\n}\n\n.no-border {\n  border: none !important;\n}\n\n.view-progess-label {\n  border-bottom: 3px dotted #5a6a85;\n  color: #5a6a85;\n  cursor: pointer;\n}\n\n.defaultBorderRadius {\n  border-radius: 10px !important;\n}\n\n.view-progess-label:hover {\n  border-bottom: 3px dotted rgb(156 161 169);\n  color: rgb(156 161 169);\n}\n\n.chip-text {\n  font-family: Plus Jakarta Sans;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 17.64px;\n  text-align: left;\n}\n\n.searchbar-styles {\n  span {\n    color: #1d2026 !important;\n    background-color: white;\n    border-color: white;\n    height: 48px;\n    border-radius: 0px !important;\n  }\n\n  input {\n    color: #8c94a3 !important;\n    background-color: white;\n    border-color: white;\n    border-radius: 0px !important;\n  }\n\n  input:focus {\n    outline: none;\n    box-shadow: none;\n    color: #8c94a3 !important;\n    background-color: white;\n    border: var(--bs-border-width) solid var(--bs-border-color);\n    border-color: white !important;\n  }\n\n  input::placeholder {\n    color: #8c94a3 !important;\n  }\n}\n\n.label-styles {\n  font-family: Plus Jakarta Sans !important;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  line-height: 22px;\n  letter-spacing: -0.01em;\n  text-align: left;\n  color: #1d2026;\n  margin-bottom: 6px;\n}\n\n.styled-text-field {\n  span {\n    font-family: Plus Jakarta Sans;\n    color: #4e5566;\n    border: 1px solid #e9eaf0;\n    background-color: white;\n    border-left-color: white;\n    height: 48px;\n    border-radius: 0px !important;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 22px;\n    letter-spacing: -0.01em;\n    text-align: right;\n  }\n\n  input {\n    font-family: Plus Jakarta Sans;\n    color: #8c94a3 !important;\n    border-top: 1px solid #e9eaf0 !important;\n    border-bottom: 1px solid #e9eaf0 !important;\n    border-left: 1px solid #e9eaf0 !important;\n    height: 48px;\n    border-radius: 0px !important;\n  }\n\n  input:focus {\n    color: #8c94a3 !important;\n    border-top: 1px solid #8b8b8e !important;\n    border-bottom: 1px solid #e9eaf0 !important;\n    border-left: 1px solid #e9eaf0 !important;\n  }\n\n  //   .input-group input:focus {\n  //   outline: none;\n  //   box-shadow: none;\n  //   color: #8c94a3 !important;\n  //   background-color: white;\n  //   border: var(--bs-border-width) solid var(--bs-border-color);\n  //   border-color: white !important;\n  // }\n\n  input::placeholder {\n    color: #8c94a3 !important;\n  }\n}\n\n.team-and-access {\n  .label-styles {\n    font-family: Plus Jakarta Sans !important;\n    font-size: 18px !important;\n    font-weight: 500 !important;\n    line-height: 24px !important;\n    text-align: left !important;\n    color: #1d2026;\n    margin-bottom: 24px !important;\n  }\n\n  .add-new {\n    font-family: Plus Jakarta Sans !important;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 20px;\n    letter-spacing: -0.01em;\n    text-align: left;\n    color: #564ffd;\n    display: flex;\n    align-items: center;\n\n    img {\n      color: #564ffd !important;\n      margin-right: 8px;\n      height: 16px;\n      width: 16px;\n    }\n  }\n}\n\n.styled-select-field {\n  .css-13cymwt-control {\n    min-height: 48px !important;\n    background-color: white;\n    border: 1px solid #e9eaf0 !important;\n    border-radius: 0 !important;\n  }\n\n  .css-13cymwt-control:focus {\n    min-height: 48px !important;\n    background-color: white;\n    border: 1px solid #e9eaf0 !important;\n    border-radius: 0 !important;\n  }\n\n  .css-1dimb5e-singleValue {\n    color: #8c94a3 !important;\n  }\n\n  .react-select__option {\n    color: #8c94a3 !important;\n  }\n\n  .singal-select__indicators {\n    min-height: 48px !important;\n  }\n\n  .singal-select__menu {\n    z-index: 2 !important;\n  }\n\n  .css-1u9des2-indicatorSeparator {\n    display: none;\n  }\n\n  .css-1xc3v61-indicatorContainer {\n    color: #1d2026;\n    svg {\n      height: 18px;\n      width: 18px;\n    }\n  }\n}\n\n.calender-select-field {\n  span {\n    font-family: Plus Jakarta Sans;\n    color: #4e5566 !important;\n    border: 1px solid #e9eaf0;\n    background-color: white;\n    border-left-color: white;\n    height: 48px;\n    border-radius: 0px !important;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 22px;\n    letter-spacing: -0.01em;\n    text-align: right;\n  }\n\n  input {\n    font-family: Plus Jakarta Sans;\n    color: #8c94a3 !important;\n    border: 1px solid #e9eaf0 !important;\n    height: 49.6px !important;\n    width: 100%;\n    border-radius: 0px !important;\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n\n  input:focus {\n    color: #8c94a3 !important;\n  }\n\n  input::placeholder {\n    color: #8c94a3 !important;\n  }\n}\n\n.styled-multi-select-field {\n  .multi-select-dropdown__multi-value {\n    display: flex;\n    min-width: 0;\n    background-color: hsl(0, 0%, 90%);\n    border-radius: 50px !important;\n    margin: 2px;\n    box-sizing: border-box;\n    padding: 1px 5px;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    -webkit-justify-content: center;\n    justify-content: center;\n    -webkit-align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 150%;\n    gap: 5px;\n  }\n\n  .multi-select-dropdown__control {\n    min-height: 48px !important;\n    background-color: white;\n    border: 1px solid #e9eaf0 !important;\n    border-radius: 0 !important;\n  }\n\n  .multi-select-dropdown__control:focus {\n    min-height: 48px !important;\n    background-color: white;\n    border: 1px solid #e9eaf0 !important;\n    border-radius: 0 !important;\n  }\n\n  .css-1dimb5e-singleValue {\n    color: #8c94a3 !important;\n  }\n\n  .react-select__option {\n    color: #8c94a3 !important;\n  }\n\n  .css-1hb7zxy-IndicatorsContainer {\n    height: 48px !important;\n  }\n\n  .css-1u9des2-indicatorSeparator {\n    display: none;\n  }\n\n  .css-1xc3v61-indicatorContainer {\n    color: #1d2026;\n    svg {\n      height: 18px;\n      width: 18px;\n    }\n  }\n}\n\n.styled-multi-select-field {\n  .multi-select-dropdown__multi-value {\n    display: flex;\n    min-width: 0;\n    background-color: hsl(0, 0%, 90%);\n    border-radius: 50px !important;\n    margin: 2px;\n    box-sizing: border-box;\n    padding: 1px 5px;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    -webkit-justify-content: center;\n    justify-content: center;\n    -webkit-align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 150%;\n    gap: 5px;\n  }\n\n  .multi-select-dropdown__control {\n    min-height: 48px !important;\n    background-color: white;\n  }\n\n  .multi-select-dropdown__control:focus {\n    min-height: 48px !important;\n    background-color: white;\n  }\n\n  .css-1dimb5e-singleValue {\n    color: #8c94a3 !important;\n  }\n\n  .react-select__option {\n    color: #8c94a3 !important;\n  }\n\n  .multi-select-dropdown__indicators {\n    min-height: 48px !important;\n  }\n\n  .css-1u9des2-indicatorSeparator {\n    display: none;\n  }\n\n  .css-1xc3v61-indicatorContainer {\n    color: #1d2026 !important;\n\n    svg {\n      height: 18px;\n      width: 18px;\n    }\n\n    svg:focus {\n      height: 18px;\n      width: 18px;\n    }\n  }\n\n  .css-1xc3v61-indicatorContainer:focus:hover {\n    color: #1d2026 !important;\n\n    svg: {\n      height: 18px;\n      width: 18px;\n    }\n\n    svg:focus {\n      height: 18px;\n      width: 18px;\n    }\n  }\n\n  .multi-select-dropdown__multi-value__remove {\n    background-image: url(\"../../../public/cross.png\") !important;\n    /* Set appropriate width and height for your custom image */\n    width: 20px;\n    height: 20px;\n    border-radius: 50px !important;\n    /* Ensure the image is displayed properly */\n    background-size: contain;\n    background-repeat: no-repeat;\n    cursor: pointer;\n    border: none !important;\n    /* Ensure cursor changes on hover */\n  }\n}\n\n.module-trash-icon {\n  cursor: pointer;\n  :hover {\n    color: #e34444 !important;\n  }\n}\n\n.styled-textarea-field {\n  textarea {\n    font-family: Plus Jakarta Sans;\n    color: #8c94a3 !important;\n    border: 1px solid #e9eaf0;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: left;\n    height: 200px;\n    resize: none;\n    border-radius: 0px !important;\n  }\n\n  textarea::placeholder {\n    color: #8c94a3 !important;\n  }\n}\n\n.styled-file-input-field {\n  .button-styles {\n    color: #4e5566 !important;\n    border: 1px solid #e9eaf0;\n    background: #e9eaf0 !important;\n    background-color: white;\n    border-left-color: white;\n    height: 48px !important;\n    color: #1d2026;\n    font-family: Plus Jakarta Sans;\n    font-size: 16px;\n    font-weight: 600;\n    border-radius: 5px !important;\n    margin-left: -8px !important;\n    z-index: 1;\n    cursor: pointer;\n  }\n\n  .input-file {\n    font-family: Plus Jakarta Sans;\n    color: #8c94a3 !important;\n    background-color: white !important;\n    border: 1px solid #e9eaf0 !important;\n    height: 48px;\n    align-items: center;\n    display: flex;\n    padding-left: 18px;\n    border-radius: 0px !important;\n    cursor: pointer;\n  }\n\n  .info-message {\n    .note {\n      font-family: Plus Jakarta Sans;\n      font-size: 14px;\n      font-weight: 500;\n      line-height: 20px;\n      letter-spacing: -0.01em;\n      text-align: left;\n      background-color: white !important;\n    }\n\n    margin: 0px !important;\n    font-family: Plus Jakarta Sans;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 22px;\n    letter-spacing: -0.01em;\n    text-align: left;\n  }\n}\n\n.styled-checkboxes-field {\n  .label-styles {\n    font-family: Plus Jakarta Sans !important;\n    font-size: 18px !important;\n    font-weight: 500 !important;\n    line-height: 24px !important;\n    text-align: left !important;\n    color: #1d2026;\n    margin-bottom: 24px !important;\n  }\n\n  .form-check-input {\n    height: 18px;\n    width: 18px;\n  }\n\n  .form-check-input:checked {\n    background-color: #564ffd !important;\n    color: #ffffff !important;\n  }\n\n  .form-check label {\n    font-family: Plus Jakarta Sans;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 22px;\n    letter-spacing: -0.01em;\n    text-align: left;\n    color: #1d2026;\n  }\n}\n\n.input-group span {\n  color: #1d2026 !important;\n  background-color: white;\n  border-color: white;\n  height: 48px;\n  border-radius: 0px !important;\n}\n\n.input-group input {\n  color: #8c94a3 !important;\n  background-color: white;\n  border-color: white;\n  border-radius: 0px !important;\n}\n\n// .input-group input:focus {\n//   outline: none;\n//   box-shadow: none;\n//   color: #8c94a3 !important;\n//   background-color: white;\n//   border: var(--bs-border-width) solid var(--bs-border-color);\n//   border-color: white !important;\n// }\n\n.input-group input::placeholder {\n  color: #8c94a3 !important;\n}\n\n.classroom-table {\n  tr {\n    height: 36px !important;\n    text-align: start !important;\n  }\n\n  td {\n    height: 36px !important;\n    padding: 0px 8px !important;\n    text-align: start !important;\n    width: inherit !important;\n    overflow: visible !important;\n  }\n\n  td > div:first-child {\n    height: 100% !important;\n    display: flex;\n    align-items: center;\n    width: 100% !important;\n  }\n\n  td:last-child {\n    overflow: visible !important;\n  }\n\n  th {\n    height: 50px !important;\n    position: relative;\n    padding: 0px 8px !important;\n  }\n\n  .table-checkbox {\n    position: absolute;\n    margin: auto;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    width: 20px;\n    height: 20px;\n  }\n\n  table input:checked {\n    background-color: $primary-color;\n  }\n}\n\n@media (max-width: 1024px) {\n  .classroom-table {\n    th {\n      font-size: 14px !important;\n      line-height: 18px !important;\n    }\n    td {\n      font-size: 12px !important;\n      line-height: 16px !important;\n    }\n    td > div,\n    th > div {\n      font-size: 12px !important;\n      line-height: 16px !important;\n    }\n  }\n}\n\n.styled-button-styles {\n  font-family: Plus Jakarta Sans;\n  font-size: 16px;\n  font-weight: 600 !important;\n  line-height: 17.34px;\n  text-align: left !important;\n  padding: 11.14px 25.46px 11.14px 25.46px !important;\n  color: #564ffd !important;\n  background-color: #ebebff !important;\n  border-color: #ebebff !important;\n\n  @media (max-width: 768px) {\n    font-size: 10px !important;\n    padding: 10px 20px !important;\n  }\n\n  @media (max-width: 480px) {\n    font-size: 10px !important;\n    padding: 7px 10px !important;\n  }\n\n  @media (max-width: 360px) {\n    font-size: 10px !important;\n    padding: 5px 7px !important;\n  }\n}\n\n.styled-button-styles:hover {\n  color: white !important;\n  background-color: #564ffd !important;\n}\n\n.styled-link-button {\n  font-family: Plus Jakarta Sans;\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  line-height: 17.34px;\n  text-align: left !important;\n  color: #564ffd !important;\n\n  @media (max-width: 768px) {\n    font-size: 14px !important;\n  }\n\n  @media (max-width: 480px) {\n    font-size: 12px !important;\n  }\n}\n\ntable input:checked {\n  background-color: $primary-color;\n}\n\n.line {\n  height: 1px;\n\n  background-color: #5a6a85;\n  width: 100%;\n\n  margin: auto;\n  margin-left: 10px;\n}\n\n.table-responsive {\n  width: 100% !important;\n  overflow: visible !important;\n}\n\n// Options Menu Styling\n.options-toggle {\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dropdown-toggle {\n  display: inline-flex !important;\n  align-items: center !important;\n}\n\n.dropdown-menu {\n  z-index: 9999 !important;\n  min-width: 120px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;\n\n  &.show {\n    display: block !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n  }\n}\n\n.dropdown-item {\n  cursor: pointer;\n\n  &:hover {\n    background-color: #f8f8f8;\n  }\n\n  &:active {\n    background-color: #f0f0f0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
